const convertToLetter = value => {
  const mod = value % 26;
  const pow = parseInt(value / 26, 10);
  const out = mod ? String.fromCharCode(64 + mod) : (pow - 1, 'Z');

  return pow ? convertToLetter(pow) + out : out;
};

export default convertToLetter;
